import React from 'react';
import { motion } from 'framer-motion';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
const fillRateData = [{
  name: 'Week 1',
  rate: 20
}, {
  name: 'Week 2',
  rate: 35
}, {
  name: 'Week 3',
  rate: 55
}, {
  name: 'Week 4',
  rate: 80
}, {
  name: 'Week 5',
  rate: 98
}];
const stationData = [{
  name: 'Medical',
  value: 100
}, {
  name: 'Marshals',
  value: 95
}, {
  name: 'Water',
  value: 93
}, {
  name: 'Reg',
  value: 96
}, {
  name: 'Logistics',
  value: 80
}];
export function Reports() {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="space-y-6" data-id="element-547">
      <div data-id="element-548">
        <h1 className="text-2xl font-display font-bold text-white mb-1" data-id="element-549">
          Reports & Analytics
        </h1>
        <p className="text-[var(--muted)] text-sm" data-id="element-550">
          Event performance and workforce insights.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-551">
        {/* Fill Rate Chart */}
        <div className="bg-[var(--surface)] border border-white/5 rounded-xl p-6" data-id="element-552">
          <h3 className="text-sm font-medium text-white mb-6" data-id="element-553">
            Staffing Fill Rate Over Time
          </h3>
          <div className="h-64 w-full" data-id="element-554">
            <ResponsiveContainer width="100%" height="100%" data-id="element-555">
              <AreaChart data={fillRateData} data-id="element-556">
                <defs data-id="element-557">
                  <linearGradient id="colorRate" x1="0" y1="0" x2="0" y2="1" data-id="element-558">
                    <stop offset="5%" stopColor="var(--accent)" stopOpacity={0.3} data-id="element-559" />
                    <stop offset="95%" stopColor="var(--accent)" stopOpacity={0} data-id="element-560" />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} data-id="element-561" />
                <XAxis dataKey="name" stroke="var(--muted)" fontSize={12} tickLine={false} axisLine={false} data-id="element-562" />
                <YAxis stroke="var(--muted)" fontSize={12} tickLine={false} axisLine={false} tickFormatter={val => `${val}%`} data-id="element-563" />
                <Tooltip contentStyle={{
                backgroundColor: 'var(--surface)',
                borderColor: 'rgba(255,255,255,0.1)',
                borderRadius: '8px'
              }} itemStyle={{
                color: 'var(--accent)'
              }} data-id="element-564" />
                <Area type="monotone" dataKey="rate" stroke="var(--accent)" strokeWidth={2} fillOpacity={1} fill="url(#colorRate)" data-id="element-565" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Station Readiness Chart */}
        <div className="bg-[var(--surface)] border border-white/5 rounded-xl p-6" data-id="element-566">
          <h3 className="text-sm font-medium text-white mb-6" data-id="element-567">
            Station Readiness (%)
          </h3>
          <div className="h-64 w-full" data-id="element-568">
            <ResponsiveContainer width="100%" height="100%" data-id="element-569">
              <BarChart data={stationData} data-id="element-570">
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} data-id="element-571" />
                <XAxis dataKey="name" stroke="var(--muted)" fontSize={12} tickLine={false} axisLine={false} data-id="element-572" />
                <YAxis stroke="var(--muted)" fontSize={12} tickLine={false} axisLine={false} data-id="element-573" />
                <Tooltip cursor={{
                fill: 'rgba(255,255,255,0.05)'
              }} contentStyle={{
                backgroundColor: 'var(--surface)',
                borderColor: 'rgba(255,255,255,0.1)',
                borderRadius: '8px'
              }} data-id="element-574" />
                <Bar dataKey="value" fill="var(--success)" radius={[4, 4, 0, 0]} data-id="element-575" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </motion.div>;
}